<template>
	<v-dialog
		v-model="showDialog"
		max-width="700"
		@click:outside="showDialog = false"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card :tile="$vuetify.breakpoint.xs">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">部品調達依頼作成</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-toolbar-title style="color: white" @click="closeDialog()"
					><v-icon>mdi-close</v-icon></v-toolbar-title
				>
			</v-toolbar>
			<v-sheet elevation="0" class="pa-2">
				<template>
					<v-form class="pa-2 mt-2" ref="form2" lazy-validation v-model="valid">
						<IncrementalSearchForm
							:url="'/erp/v1/incremental/components'"
							:label="'部品名と部品品番で検索'"
							:items="items"
							:returnObject="true"
							:value.sync="value"
							:no-data-text="'部品が見つかりません'"
							:clearable="true"
							:keywordKey="'component_name_and_part_number_cont'"
							:itemText="'component_name_and_part_number'"
						/>
						<div class="quantity-field-area" v-if="value">
							<v-row no-gutters align="center">
								<v-col cols="12" sm="6">
									<v-row no-gutters>
										<v-col cols="12" sm="11">
											<p v-if="value" class="pb-4 ml-4">
												部品名：{{ value.name }}　　品番：{{ value.part_number }}
											</p>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
							<v-row no-gutters class="top-divider" align="center">
								<v-col cols="6">
									<v-text-field
										v-model="quantity"
										class="mt-2 append-outer"
										label="数量(必須)"
										outlined
										dense
										:rules="[rules.required]"
									>
									</v-text-field>
								</v-col>
								<v-col cols="6">
									<v-menu
										ref="menu"
										v-model="menu1"
										:close-on-content-click="false"
										:nudge-right="40"
										transition="scale-transition"
										offset-y
									>
										<template v-slot:activator="{ on }">
											<v-text-field
												v-model="expectedReceivingDate"
												label="希望納期(必須)"
												readonly
												outlined
												dense
												v-on="on"
												:rules="[rules.required]"
												class="mt-2 ml-2"
											></v-text-field>
										</template>
										<v-date-picker
											v-model="expectedReceivingDate"
											no-title
											scrollable
											locale="ja"
											@input="menu1 = false"
										>
										</v-date-picker>
									</v-menu>
								</v-col>
								<v-col cols="6">
									<v-text-field
										v-model="subtitle"
										class="mt-2 append-outer"
										label="サブタイトル"
										outlined
										dense
									>
									</v-text-field>
								</v-col>
							</v-row>
							<v-row no-gutters>
								<v-col cols="12">
									<v-textarea
										v-model="message"
										class="mt-2"
										label="依頼理由(必須)"
										outlined
										:rules="[rules.required]"
									>
									</v-textarea>
								</v-col>
							</v-row>
						</div>
						<v-btn dark color="secondary" class="mt-4" @click="$refs.uploadFile.click()">
							<v-icon class="mr-2">mdi-paperclip-plus</v-icon>
							添付ファイルを追加
							<input
								type="file"
								class="d-none"
								ref="uploadFile"
								@change="addFiles($event)"
								multiple
							/>
						</v-btn>

						<div class="file-area mt-2">
							<span v-if="allFiles < 1" class="filename">選択されていません</span>
							<template v-else>
								<v-chip
									class="ma-1 mt-2"
									close
									label
									outlined
									color="primary"
									@click:close="removeFile(i)"
									v-for="(file, i) in files"
									:key="file.name"
								>
									<v-icon class="mr-1">mdi-paperclip</v-icon>
									{{ file.name }}
								</v-chip>
							</template>
						</div>
					</v-form>
				</template>
				<v-row class="ma-0 pa-0" justify="center">
					<v-btn
						:disabled="!componentSearchDialogDisabled"
						class="ma-1 white--text font-weight-bold"
						@click="openComponentProcurementConfirmationDialog()"
						dense
						color="secondary"
					>
						<v-icon class="mr-2">mdi-checkbox-marked-outline</v-icon>
						作成する</v-btn
					>
				</v-row>
				<ComponentProcurementConfirmationDialog
					:dialog.sync="confirmationDialog"
					:createRequirementFlag="createRequirementFlag"
					@createRequirement="createRequirement"
					:dialogTitle="dialogTitle"
					:dialogContent="dialogContent"
				/>
			</v-sheet>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import rules from "../../../helper/rules"
import moment from "moment"
import "moment/locale/ja"
import OrderedProductSearchResult from "./OrderedProductSearchResult.vue"
import ComponentProcurementConfirmationDialog from "./ComponentProcurementConfirmationDialog.vue"
import IncrementalSearchForm from "../../shared/IncrementalSearchForm.vue"
import PaginationModule from "../../../modules/PaginationModule.vue"

export default {
	components: {
		OrderedProductSearchResult,
		IncrementalSearchForm,
		PaginationModule,
		ComponentProcurementConfirmationDialog,
	},
	props: {
		dialog: {
			type: Boolean,
			required: false,
			default: false,
		},

		requirement_id: {
			type: null,
			required: false,
		},
	},
	data() {
		return {
			valid: false,
			rules: rules,
			requirement: {},
			selectedOrderedProduct: null,
			ordered_products: [],
			orderedProductResultFlag: false,
			confirmationDialog: false,
			orderedProduct: null,
			orderedProductErrorFlag: false,
			ordered_product_keyword: null,
			searchOrderedProductTimer: null,
			orderComponents: [],
			selectedOrderComponent: [],
			quantityFields: [],
			quantity: "",
			files: [],
			removefiles: [],
			menu1: false,
			expectedReceivingDate: null,
			confirmationDialog: false,
			label: "製品検索",
			searchWord: null,
			searchNumber: null,
			openDataTable: false,
			headers: [
				// { text: "選択", value: "", width: "50px", divider: true },
				{ text: "部品品番", value: "part_number", width: "200px", divider: true },
				{ text: "部品名", value: "name", width: "200px", divider: true },
			],
			items: [],
			value: null,
			dialogTitle: "",
			dialogContent: "",
			message: "",
			subtitle: "",
			createRequirementFlag: false,
		}
	},

	methods: {
		closeDialog() {
			this.value = ""
			this.quantity = ""
			this.subtitle = ""
			this.expectedReceivingDate = ""
			this.message = ""
			this.files = []
			this.showDialog = false
			this.$emit("resetForm")
		},

		addFiles(e) {
			const files = e.target.files
			Object.entries(files).forEach((file) => {
				this.files.push(file[1])
			})
		},
		removeFile(index) {
			const removeFile = this.files[index]
			this.files.splice(index, 1)
			this.removefiles.push(removeFile)
		},

		openComponentProcurementConfirmationDialog() {
			this.dialogTitle = "部品調達依頼作成"
			this.dialogContent = "部品調達依頼を作成しますか？"
			this.createRequirementFlag = true
			this.confirmationDialog = true
		},

		createRequirement() {
			const headers = authenticate.setHeader()
			let formData = new FormData()

			if (this.files.length) {
				this.files.forEach((file) => {
					formData.append(
						"files" + "[]",
						new Blob([file], {
							type: file.type,
						}),
						file.name
					)
				})
			}
			if (this.selectedOrderedProduct && this.selectedOrderComponent) {
				formData.set("requirement[ordered_product_id]", this.selectedOrderedProduct.id)
				formData.set("requirement[order_component_id]", this.selectedOrderComponent.id)
				formData.set("requirement[component_id]", this.selectedOrderComponent.component.id)
				formData.set("requirement[quantity]", this.quantity)
				formData.set("requirement[subtitle]", this.subtitle)
				formData.set("requirement[expected_receiving_date]", this.expectedReceivingDate)
				formData.set("requirement[message]", this.message)
			} else {
				formData.set("requirement[component_id]", this.value.id)
				formData.set("requirement[quantity]", this.quantity)
				formData.set("requirement[subtitle]", this.subtitle)
				formData.set("requirement[expected_receiving_date]", this.expectedReceivingDate)
				formData.set("requirement[message]", this.message)
			}

			axios
				.post(
					`/erp/v1/component_procurement_requirements/component_procurement_requirements`,
					formData,
					{
						headers,
					}
				)
				.then((res) => {
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "部品調達依頼を作成しました",
					})
					this.closeDialog()
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},

		componentSearchDialogDisabled() {
			return this.value && this.quantity && this.expectedReceivingDate && this.message
		},

		allFiles() {
			if (this.files) {
				return this.files.length
			}
		},
	},
}
</script>

<style scoped lang="scss"></style>
